import { getAdsSettingsApi, getAdsPointsSettingApi, updateAdsSettingsApi, updateAdsPointsSettingApi } from "../components/constant/Api";
import { myApi } from "./api";

export const adsApi = myApi.injectEndpoints({
    endpoints: (builder) => ({
        getAdsSettings: builder.query({
            query: () => ({
                url: getAdsSettingsApi,
                method: "GET",
            }),
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: ["adsSettings"],
        }),
        updateAdsSettings: builder.mutation({
            query: (post) => ({
                url: updateAdsSettingsApi,
                method: "POST",
                body: post,
            }),
            invalidatesTags: ["adsSettings"],
        }),
        getAdsPointsSetting: builder.query({
            query: () => ({
                url: getAdsPointsSettingApi,
                method: "GET",
            }),
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: ["adsPointsSetting"],
        }),
        updateAdsPointsSetting: builder.mutation({
            query: (post) => ({
                url: updateAdsPointsSettingApi,
                method: "POST",
                body: post,
            }),
            invalidatesTags: ["adsPointsSetting"],
        }),
    }),
});

export const {
    useGetAdsSettingsQuery,
    useUpdateAdsSettingsMutation,
    useGetAdsPointsSettingQuery,
    useUpdateAdsPointsSettingMutation,
} = adsApi;
